<template>
<div class="content content--onepane">
  <form class="form">
    <div class="form-side">
      <div class="form-row">
        <input class="form-text" type="text" v-model="formData.name">
      </div>
      <div class="form-row">
        <input class="form-text" type="text" v-model="formData.title">
      </div>
      <button @click.prevent="saveNote">Save</button>
    </div>
    <div class="form-belly">
      <longform-editor v-model="formData.body" placeholder="Notes">
      </longform-editor>
    </div>
  </form>
</div>
</template>

<script>
import firebase from 'firebase';
import * as Firebase from '../config.js';

import Note from '../helpers/Note';
import marked from 'marked';

export default {
  data(){ return{
    editMode: false,

    formData: {
      body: ''
    }
  }},

  firebase: {
    notes: Firebase.notes
  },

  methods: {
    saveNote(){
      //validate, make this into its own class later
      let valid = true;
      let errors = [];

      if(this.formData.name === ''){
        valid = false;
        errors.push('Empty name');
      }

      if(this.formData.title === ''){
        valid = false;
        errors.push('Empty title');
      }

      if(this.formData.body === ''){
        valid = false;
        errors.push('Empty body');
      }

      //sanitise
      this.formData.name = this.formData.name.toUpperCase();
      this.formData.updated = (new Date).toISOString();

      //check if name already exists

      if(valid){
        Firebase.notes.child(this.formData.name).set(this.formData);
        this.$router.push('/note/' + this.formData.name);
      }
    }
  },

  mounted(){
    if(this.$route.params.name){
      //is in edit mode
      this.editMode = true;
      Note.get(this.$route.params.name).then(snapshot => {
        this.formData = snapshot.val();
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// newnote.vue?67a4c15b